import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'

export const ErrorMessage = ({ value, className, isI18n, ...others }) => {
  return (
    <Element
      className={`fstItalic ${className}`}
      style={{ color: '#E0505B', marginTop: 4, marginBottom: 4 }}
    >
      {value ? (
        isI18n ? (
          <Translate value={value} {...others} />
        ) : (
          value
        )
      ) : (
        <>&nbsp;</>
      )}
    </Element>
  )
}

ErrorMessage.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  isI18n: PropTypes.bool,
}

ErrorMessage.defaultProps = {
  isI18n: true,
}
